module.exports = __webpack_public_path__ + "static/media/subICloud3.8f13ebe3.png";